import React from 'react';
import {gql} from "@apollo/client";
import client from '../../src/graphql/client';
import {get} from 'lodash';
import styled from '@emotion/styled';
import { theme } from '../../src/themes/default-theme';
import topo from '../../src/assets/topo.png';
import Text from '../../src/components/typography';
import { Cta } from '../../src/components/ui';

const Container = styled.div`
    padding: 65px 0;
    position: relative;
    background-color: ${theme.palette.lightGrey};

    &:before {
        height: 60px;
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        background-position: center top;
        background-image: url(${topo});
        background-size: 400px auto;
        background-repeat: repeat-x;
    }
`
const Wrapper = styled.div`
  padding-left: 20px;
  padding-right: 20px;
  text-align: center;
  h1 {
    margin-bottom: 45px;
  }
  > a {
    max-width: 200px;
    font-size: 15px;
    font-weight: 700;
    margin-top: 57px;
  }
  ${theme.breakpoints.up('md')} {
      padding-left: 40px;
      padding-right: 40px;
      margin-top: 65px;
      h1 {
        font-size: 34px;
        line-height: 38px;
      }
  }
  ${theme.breakpoints.down('sm')} {
    margin-top: 56px;
    h1 {
      font-size: 32px;
      line-height: 36px;
    }
}
`

const ThankYou = (props) => {

  return (
    <Container>
        <Wrapper>
            <Text variant="h1" colour="charcoal" align="center" uppercase weight={800}>Thank you</Text>
            <Text variant="body1" align="center">Your request has been submitted. We’ll be in touch as soon as possible to finalise all the details.</Text>
            <Cta
            href={'/'}
            primary
            uppercase
            >Back to home</Cta>
        </Wrapper>
    </Container>
  )
}

ThankYou.propTypes = {

}

export async function getStaticProps() {

  const countryCode = process.env.DEV_COUNTRY_CODE ? process.env.DEV_COUNTRY_CODE : process.env.COUNTRY_CODE;
  

  return {
    revalidate: (process.env.NEXT_STATIC_EXPORT && process.env.NEXT_STATIC_EXPORT.toString() === 'true') ? false : 1,
    props: {
        countryCode,
        greyBg: true
    }
  }
}


export default ThankYou
